var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-container"},[_c('el-card',{staticClass:"admin-tip"},[_vm._v(" "+_vm._s(_vm.$t('dashboard.now_time', { nickname: _vm.nickname, nowTimeCall: _vm.nowTimeCall, nowTime: _vm.nowTime }))+" ")]),_c('panel-group')],1)}
var staticRenderFns = []

export { render, staticRenderFns }